import Button from './Button';
import './style/SetWarehouseLocationModal.css';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setShowModal, setWarehouseLocations } from '../../redux/keystoneInterfaceSlice';
import { AddressElement, Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import info from '../../media/info32@3x.png';
import Icon from './Icon';
import { Text } from '@harperai/materialize-design-system';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_TOKEN);

const options = {
    fonts: [
        {
            cssSrc: 'https://fonts.googleapis.com/css2?family=Figtree:ital,wght@0,300..900;1,300..900&family=JetBrains+Mono:ital,wght@0,100..800;1,100..800&display=swap',
        }
    ],
    appearance: {
        theme: 'stripe',
        variables: {
            fontFamily: `'Figtree', sans-serif`,
            '--ks-blue-dark': '#6f7aa5',
            '--ks-box-shadow-shallow': '0 2px 8px rgba(230, 232, 240, 0.5)',
            '--ks-divider': '#E6E8F0',
        },
        rules: {
            '.Label': {
                fontFamily: 'Figtree',
                fontWeight: 'bold',
                fontSize: '16px',
                lineHeight: '20px',
                color: 'black',
            },
            '.Input': {
                fontFamily: 'JetBrains Mono',
                paddingTop: '9px',
                paddingBottom: '9px',
                paddingLeft: '12px',
                paddingRight: '12px',
                fontSize: '14px',
                lineHeight: '16px',
                borderRadius: '4px',
                backgroundColor: 'white',
                boxShadow: '0 2px 8px rgba(230, 232, 240, 0.5)',
                outline: 'none',
                border: '1px solid #E6E8F0',
            },
            '.Input:focus': {
                backgroundColor: 'white',
                borderRadius: '4px',
                border: '1px solid #6f7aa5',
                boxShadow: 'none',
            },
            '.Input::placeholder': {
                color: '#6f7aa5',
            }
            
        }
    }
};

const SetWarehouseLocationModal = ({ handleDimiss }) => {
    const dispatch = useDispatch();
    const keystoneInterfaceAccessToken = useSelector((state) => state?.keystoneInterface?.accessToken);
    const warehouseName = useSelector((state) => state?.keystoneInterface?.editingWarehouseName);
    const keystoneInterfaceCompanyWarehouseLocations = useSelector((state) => state?.keystoneInterface?.companyWarehouseLocations);
    const keystoneInterfaceSettingWarehouseLocations = useSelector((state) => state?.keystoneInterface?.settingWarehouseLocations);
    const keystoneInterfaceSetWarehouseLocationSuccessfully = useSelector((state) => state?.keystoneInterface?.setWarehouseLocationsSuccessfully);
    const [address, setAddress] = useState(null);
    const [showTooltip, setShowTooltip] = useState(false);

    const existingWarehouseAddress = keystoneInterfaceCompanyWarehouseLocations?.[warehouseName]?.address;


    const handleAddressChange = (event) => {
        console.log(event);
        setAddress(event);
    };

    const setWarehouseLocation = () => {
        const { line1, line2, city, country, postal_code, state } = address?.value.address;
        const formattedAddress = {
            name: address?.value.name,
            line1,
            line2,
            city,
            region: state,
            postal_code,
            country
        };
        dispatch(setWarehouseLocations({ accessToken: keystoneInterfaceAccessToken, warehouse_locations: {
            ...keystoneInterfaceCompanyWarehouseLocations,
            [warehouseName]: {
                address: formattedAddress
            }
        }}))
    };

    useEffect(() => {
        if (keystoneInterfaceSetWarehouseLocationSuccessfully) {
            if (handleDimiss) {
                handleDimiss();
            } else {
                dispatch(setShowModal(false));
            }
        }
    }, [dispatch, handleDimiss, keystoneInterfaceSetWarehouseLocationSuccessfully])
    
    return (
        <div className="keystone-locations-setup-modal product-vertical-container overflow-x-visible">
            <div className="product-vertical-container flex-1 space-between v-gap-s">
                <div className="product-vertical-container v-gap-m pad-m pad-h-l">
                    <div className='product-horizontal-container h-gap-m flex-1 justify-center'>
                        <div className='product-horizontal-container h-gap-xs align-center'>
                            <Text header={2} size="paragraph" bold={true}>Warehouse Name:</Text>
                            <Text header={3} size="paragraph">{warehouseName}</Text>
                            <Icon icon={info} size="10" color="#b9bfd6" handleMouseEnter={(e) => setShowTooltip(true)} handleMouseLeave={(e) => setShowTooltip(false)}>
                                    {showTooltip && (
                                            <div className="modal-tooltip" style={{marginLeft: '14px', marginTop: '14px'}}>
                                                <Text header={2} size="paragraph">Your unique name for this warehouse location. This should not change between updates.</Text>
                                            </div>
                                        )}
                            </Icon>
                        </div>
                    </div>
                    <Elements stripe={stripePromise} options={options}>
                        <AddressElement
                            onChange={handleAddressChange}
                            options={{
                                mode: 'shipping',
                                display: {
                                    name: 'full',
                                },
                                autocomplete: {
                                    mode: 'google_maps_api',
                                    apiKey: 'AIzaSyD0_wONkOnNgrtMp4tUY4FsLUawwZvvaPk',
                                },
                                defaultValues: {
                                    name: existingWarehouseAddress?.name,
                                    address: {
                                        line1: existingWarehouseAddress?.line1,
                                        line2: existingWarehouseAddress?.line2,
                                        city: existingWarehouseAddress?.city,
                                        state: existingWarehouseAddress?.region,
                                        postal_code: existingWarehouseAddress?.postal_code,
                                        country: existingWarehouseAddress?.country
                                    }
                                }
                            }}
                        />
                    </Elements>
                </div>
                <div className="product-horizontal-container justify-end pad-l h-gap-s">
                    <Button brand={true} disabled={!address?.complete} loading={keystoneInterfaceSettingWarehouseLocations} label="Submit" large="true" onClick={setWarehouseLocation} />
                </div>
            </div>
        </div>
    );
};

export default React.memo(SetWarehouseLocationModal);